import React, { useState,useEffect } from 'react'
import {MDBRow, MDBCol, MDBInput, MDBBtn , toast,MDBModal,MDBModalBody,MDBModalHeader,MDBIcon} from 'mdbreact';
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from 'axios';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from '../components/WarningBox';
import InfoBox from '../components/InfoBox';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { set } from 'date-fns';




const DeleteSalesMain=(props)=>{

    const useMountEffect = (functionName) => useEffect(functionName, [])
       const serverURL=props.apiServer 
 ;

 const bearer={
  headers: {
     Authorization: "Bearer " + sessionStorage.getItem("hash")
  }
}


  const [frm, setValues] = useState({
    // code:"new"
    code:props.code
  
    ,discountcode:{value: '0', label:'[NO DISCOUNT]'}
    ,transactiondatetime:new Date()
    ,usercode:sessionStorage.getItem("msal.uc")
    ,deleted:false
    ,paid:true
    ,datepaid:new Date()
    ,paymentmode:{value: '1', label:'Cash'}
    ,referenceno:''
  });
  
  
 const [isUpdated,setUpdated]=useState(false);
  const [unitofmeasure,setUnitOfMeasure]=useState('');
  const [disabled,setDisabled]=useState('');
     
  const updateField = e => {
       
        const target=e.target;
       
        let  value =target.value;
        let name=target.id;
      
        if(target.type==="checkbox")
        {
          value=target.checked;
          setValues({ ...frm, [name]: value });
        }
        else
        {
          setValues({ ...frm, [name]: value });
        }
  
       

  };
  

  
  const  handleChange = objName => (selOption) => {
  
    setValues({ ...frm, [objName]: selOption });


    // if(objName==="itemcode")
    // {

    //     var str = selOption["label"];
    //     var sStart = str.lastIndexOf("<") + 1;
    //     var sEnd= str.lastIndexOf(">");
    //     var tmpunitofmeasure = str.substring(sStart, sEnd);
    //    console.log(tmpunitofmeasure);
    //    setUnitOfMeasure(tmpunitofmeasure.toUpperCase());
    // }
    
 };
  

    
  const getDateValue = dtPickerName =>(actualValue)=>{

        setValues({ ...frm, [dtPickerName]:actualValue});
  
  } 

  
   
      
   
  function submitHandler (event)
  {
        event.preventDefault();
        event.target.className += " was-validated";
        
        
        savesalesadmin();
       props.refreshGrid();
        
  };
    

  const [errorMessage,setErrorMessage]=useState("");

  const [modalWarning,showWarningBox]=useState(false);
  
  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  
    }


  const [modalInfo,showInfoBox]=useState(false);
  
 

  const toggleInfoBox = () => {
    showInfoBox(!modalInfo);
  
}

  

  


 

  const ClearFields=()=>{
    setValues({ ...frm,
        code:"new"
    
   

    ,transactiondatetime:new Date()
    ,usercode:sessionStorage.getItem("msal.uc")
    ,discountcode:{value: '0', label:'[NO DISCOUNT]'}
    ,deleted:false
    ,paid:true
    ,datepaid:new Date()
    ,paymentmode:{value: '1', label:'Cash'}
    ,referenceno:''

   
    
 
      });   


  }

 
  const loadtransactionsalesmain=()=>
  {
   

    if(props.code==="new")
    {
       setDisabled('');
        ClearFields();
        return;
    }
    setDisabled('disabled');
    Axios.get(serverURL + '/loadtransactionsalesadmin/?code=' + props.code ,bearer)
      .then(res => 
      {
        if(res.data!=="empty")
        {
          setDisabled('disabled');
            setValues({ ...frm,

                code:props.code
                ,transactiondatetime: new Date(res.data.transactiondatetime)
              
                ,deleted:res.data.deleted
                
            });   
                  
                  
        }
        else
        {
       
           ClearFields();
        }
           
    
      })
      
      .catch(error => {
        setErrorMessage(error);
        toggleWarningBox();
          
      });  
    
         
  }


  const savesalesadmin=()=> {
    

     const data =frm;
 

    Axios.post(props.apiServer + "/savesalesadmin", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
 
            
            setValues({...frm, code : res.data.code});
           
              
          
       }
       else {
       
        toast.warning(res.data.message, {
            closeButton: false
            
          });
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
         console.log(res.data.message);
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     }); 
   
    //  loadtransactionsalesmain();
 }






useEffect(() => {
  loadtransactionsalesmain();
   
}, [props.code]);


// useMountEffect(loadSeedPlanting);






    return (
        <React.Fragment>
       
          
                <MDBRow>
                <MDBCol md="12">
              
                    <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
                     

                 
                

                
                   <MDBRow >
                      <MDBCol md="6">
                      
                      <MDBInput  
                      
                      value={frm.code} 
                      id="code"  
                      label="Customer Ticket" 
                      disabled
                      className="font-weight-bold black-text"
                      >
                           <div className="invalid-feedback">
                           This field is required!
                      </div>
                      <div className="valid-feedback"></div>

                  </MDBInput>
                        </MDBCol>
                        <MDBCol md="6">
                        <label className="grey-text"><small>&nbsp;Transaction Date</small></label>
                        <br/>
                        <DatePicker
                        
                        placeholderText="mm/dd/yyyy"
                        selected={frm.transactiondatetime}
                         onChange={getDateValue("transactiondatetime")}  
                         disabled
                        />
                        <br/><br/>
                        </MDBCol>
                      
                   </MDBRow>
                

                  

                  


                    <MDBRow  >
                       <MDBCol md="12">
                       <MDBInput  
                      
                      
                      id="deleted" 
                      label="Deleted" 
                      type="checkbox"
                      checked={frm.deleted}
                      onChange={updateField}
                      
                     >
                      
                          <div className="invalid-feedback">
                          This field is required!
                      </div>
                      <div className="valid-feedback"></div>

                  </MDBInput>
                      
                       </MDBCol>

                       
                      
                   </MDBRow>


                    
                   

               
                  
                    

                   
                   <MDBBtn className="blue lighten-1" type="submit" >
                        Save
                    </MDBBtn>
                   
                  
                   
                    </form>
                    
                </MDBCol>
            </MDBRow>


              
           


            <InfoBox errorMessage={errorMessage} isOpen={modalInfo} toggleModal={toggleInfoBox} />
            <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
            {/* <MessagePersonalInfo /> */}
        </React.Fragment>
    );

}
export default DeleteSalesMain;
